// instance methods
export const INSTANCE_METHODS = {
    TEXTAREA_ADD_NEW_LINE: "textareaAddNewLine",
    TEXTAREA_SELECT: "textareaSelect",
};
